<template>
  <vuex-table
    :fields="fields"
    :show_per_page="false"
    :auto_start="false"
    :select_filter_message="$t('shared.component.table.need_select_filter')"
    table_store="phone-number/numbers/buy"
  >
    <template slot="actions" slot-scope="{ item }">
      <numbers-buy-table-cell-action :item="item" />
    </template>
  </vuex-table>
</template>

<script>
  import NumbersBuyTableCellAction from '@phone-number/components/numbers-buy-table-cell-action';

  export default {
    components: { NumbersBuyTableCellAction },
    computed: {
      fields: function () {
        return [
          {
            key: 'number',
            label: this.$t('phone-number.number.field.number'),
            thStyle: {
              minWidth: '200px'
            },
            sortable: false
          },
          {
            key: 'region',
            label: this.$t('phone-number.number.field.region'),
            sortable: false,
            thStyle: {
              minWidth: '220px'
            }
          },
          {
            key: 'capabilities',
            label: this.$t('phone-number.number.field.capabilities'),
            sortable: false,
            thStyle: {
              minWidth: '150px'
            }
          },
          {
            key: 'subscription_fee',
            label: this.$t('phone-number.number.field.subscription_fee'),
            sortable: false,

            formatter: (value) => {
              return this.$numeral.currency(value);
            }
          },

          {
            key: 'connection_cost',
            label: this.$t('phone-number.number.field.connection_cost'),
            sortable: false,

            formatter: (value) => {
              return this.$numeral.currency(value);
            }
          },
          {
            key: 'actions',
            label: this.$t('shared.component.table.actions'),
            thStyle: {
              minWidth: '220px'
            },
            sortable: false
          }
        ];
      }
    }
  };
</script>
